import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-remarriage-status-title']),
    stillRemarried: yesNoUI({
      title: content['household-remarriage-status-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['stillRemarried'],
    properties: {
      stillRemarried: yesNoSchema,
    },
  },
};
